/**
 * @module use-cases/settings/actions
 * @desc Settings Action Creators
 *
 */

import { createAsyncAction } from 'core/use-cases/utilities';

import type { Settings } from 'core/domains';

export const settingsFetch = createAsyncAction<'settingsFetch', string, Settings['data'], string>(
  'settingsFetch',
);
